module.exports = __webpack_public_path__ + "img/img_2.2ce5637e.jpg";